import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import "../../Home.css";
import { useLocation } from "react-router-dom";

const PrivacyPolicy = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">PRIVACY NOTICE</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-content pt-50 pb-50">
        <div className="site-width">
          <div className="about-card">
            <div className="titleSection text-center wow animate__fadeInDown">
              <h3>HOURLEE (RightO Services Private Ltd.) - PRIVACY NOTICE</h3>
            </div>

            <p>
              <strong>Effective Date:</strong> 07 January 2026
              <br /> <strong>Last updated:</strong>&nbsp; 07 January 2026
            </p>
            <h3>
              <strong>1. Introduction </strong>
            </h3>
            <h3>
              RightO Services Private Ltd., trading as <strong>Hourlee</strong>{" "}
              (&ldquo;Hourlee&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;,
              &ldquo;our&rdquo;), operates a digital marketplace that connects
              Job Seekers and Employers and publishes Job Posts. This Privacy
              Notice explains:
            </h3>
            <ul>
              <li>
                What personal data we collect and why;
                <br />{" "}
              </li>
              <li>
                How we use, share, and protect that data;
                <br />{" "}
              </li>
              <li>
                The legal bases for processing (including GDPR and DPDP 2023,
                where applicable); and
                <br />{" "}
              </li>
              <li>
                The rights available to individuals and how to exercise them.
                <br />{" "}
              </li>
            </ul>
            <p>
              This Notice applies to personal data processed in connection with
              Hourlee services (web, mobile apps ). If you are an EU resident,
              the GDPR applies to our processing of your personal data; if you
              are in India, the DPDP Act 2023 applies. We also aim to comply
              with other applicable local privacy laws.
            </p>
            <h3>
              <strong>2. Key terms </strong>
            </h3>
            <ul>
              <li>
                <strong>
                  &ldquo;Personal data / personal information&rdquo;
                </strong>{" "}
                - any information identifying an individual or which can
                reasonably identify them.
                <br />{" "}
              </li>
              <li>
                <strong>&ldquo;Data Principal / Data Subject&rdquo;</strong> -
                the individual whose personal data is processed (job seeker,
                contact person, etc.).
                <br />{" "}
              </li>
              <li>
                <strong>&ldquo;Data Fiduciary / Controller&rdquo;</strong> -
                RightO Services Private Ltd. trading as <strong>Hourlee</strong>{" "}
                (we determine why and how data is processed).
                <br />{" "}
              </li>
              <li>
                <strong>&ldquo;Processor&rdquo;</strong> - third-party service
                providers acting on our instructions.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>3. Personal data we collect </strong>
            </h3>
            <h3>
              <strong>
                3.1 Job Seeker profile (collected from the Job Seeker or via
                their use of the platform)
              </strong>
            </h3>
            <ul>
              <li>
                <strong>Identity &amp; Contact Information</strong> - User ID,
                Name, Phone Number, Email Address, Image (Profile Photo).
              </li>
              <li>
                <strong>Demographic / Identity</strong>{" "}
                <strong>Information</strong> -&nbsp; Date of Birth, Gender,
                Address / State / City / Pincode.
              </li>
              <li>
                <strong>Professional Profile Information</strong> -&nbsp; Job
                Profile, Industry Type, Experience (Months/Hours), Skills,
                Education, Resume, Additional Skills.
              </li>
              <li>
                <strong>Government/Verification IDs</strong>{" "}
                <strong>Information</strong> - PAN Card Number, Aadhar Card
              </li>
              <li>
                <strong>Platform Metadata</strong> <strong>Information</strong>{" "}
                -&nbsp; Account Activity logs, timestamps.
              </li>
              <li>
                <strong>Banking Information</strong> - Bank Account Details
              </li>
            </ul>
            <p>
              <br /> <strong>3.2 Employer / Company profile</strong>
            </p>
            <ul>
              <li>
                <strong>Identity &amp; Contact Information</strong> -User ID,
                Company Name / Employer Name, Contact Person Name, Phone Number,
                Alternate Phone Number, Email, Company Address / Employer
                Address, State, City, Pincode, Image.
              </li>
              <li>
                <strong>Business &amp; Compliance Information </strong>-
                Industry Type, Pan Card Number (Of Company/Person As Required),
                Gst Number + Certificate Upload, And About The Company.
              </li>
              <li>
                <strong>Banking Information </strong>- Bank Account Details
              </li>
            </ul>
            <p>
              <br /> <strong>3.3 Job Post data</strong>
            </p>
            <ul>
              <li>
                <strong>Job &amp; Posting Information </strong>- User Id,
                Company Id, Category, Industry Type, Job Title, Job Description,
                Job Type (Hourly/Project/Permanent), Skills, Experience
                (Required), Working shift / Num Of Hours Per Day, Salary Type
                (Monthly/Hourly), Min Salary, Max Salary, Hourly Rate, Other
                Field, Work Mode (Work From Office / Remote), Status, Expired
                Date.
                <br /> <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>4. How we collect personal data</strong>
            </h3>
            <p>We obtain personal data:</p>
            <ul>
              <li>
                Directly from you when you register, create/complete a profile,
                upload documents (PAN, GST, resume), post or apply to jobs, or
                contact support.
                <br />{" "}
              </li>
              <li>
                From your activity on our Service (usage, logs, cookies).
                <br />{" "}
              </li>
              <li>
                From third parties (verification vendors, publicly available
                sources, background check providers) when you consent or where
                permitted.
                <br />{" "}
              </li>
            </ul>
            <p>
              We will always make clear at the point of collection whether a
              field is mandatory, and the consequences of not providing it
              (e.g., inability to receive payouts without bank/PAN details).
            </p>
            <h3>
              <strong>5. Purposes of processing &amp; lawful bases</strong>
            </h3>
            <p>
              We process personal data only for specific purposes, on lawful
              bases under GDPR (Article 6) and permitted grounds under DPDPA
              (Section 4 &amp;7).
            </p>
            <h3>
              <strong>5.1. Legal Grounds for Processing</strong>
            </h3>
            <p>
              As required under <strong>Article 6 of the GDPR</strong>, we
              process personal data only when a valid legal basis applies. The
              lawful grounds we rely on include:
            </p>
            <p>
              <strong>
                Consent (Article 6(1)(a))
                <br />{" "}
              </strong>
              We process your personal data when you have clearly agreed to us
              doing so for specific purposes, such as receiving marketing
              updates. You may withdraw your consent at any point, and this will
              not affect any processing that took place before your withdrawal.
            </p>
            <p>
              <strong>
                Performance of a Contract (Article 6(1)(b))
                <br />{" "}
              </strong>
              We may process your information when it is necessary to fulfill a
              contract with you, or to take steps at your request before
              entering into a contract. Example, to deliver the services you ask
              for.
            </p>
            <p>
              <strong>
                Legal Obligation (Article 6(1)(c))
                <br />{" "}
              </strong>
              We process certain personal data when required to comply with
              legal duties applicable to us, such as tax requirements,
              accounting rules, regulatory inquiries, or lawful orders from
              authorities.
            </p>
            <p>
              <strong>
                Legitimate Interests (Article 6(1)(f))
                <br />{" "}
              </strong>
              We may process your data when it is necessary for our legitimate
              business interests or those of a third party, as long as these
              interests do not override your fundamental rights and freedoms.
              Examples include maintaining security, preventing fraudulent
              activity, and enhancing our services.
              <br /> Before relying on this basis, we conduct a documented
              legitimate interest assessment as required under the GDPR.
            </p>
            <h3>
              <strong>5.2 Legal Basis for Processing Your Personal Data</strong>
            </h3>
            <p>
              We handle your personal data only when we have a lawful basis to
              do so, as required by the{" "}
              <strong>Digital Personal Data Protection Act, 2023</strong>. This
              means we will collect, use, or process your data only under the
              following circumstances:
            </p>
            <ul>
              <li>
                <strong>
                  You have provided explicit, informed, and specific consent
                </strong>{" "}
                allowing us to process your personal data.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Processing is necessary for entering into or fulfilling a
                  contract
                </strong>{" "}
                with you, such as delivering services or responding to your
                requests.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Processing is required to meet a legal obligation
                </strong>{" "}
                that applies to us under relevant laws.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Processing is essential in situations involving a medical
                  emergency
                </strong>{" "}
                or to safeguard your life, health, safety, or that of another
                individual.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Processing is needed for the performance of duties by the
                  State
                </strong>
                , as permitted or mandated by law.
                <br />{" "}
              </li>
            </ul>
            <p>
              We do not process your personal data for any purpose unless a
              lawful ground under the DPDP Act clearly supports it.
            </p>
            <h3>
              <strong>6. Cookies &amp; tracking </strong>
            </h3>
            <p>
              We use cookies and similar technologies to provide, secure, and
              improve Hourlee, classified as:
            </p>
            <ul>
              <li>
                <strong>Essential cookies</strong> (session/authentication) -
                required to use the service;
                <br />{" "}
              </li>
              <li>
                <strong>Functionality cookies</strong> - remember preferences;
                <br />{" "}
              </li>
              <li>
                <strong>Performance/analytics cookies</strong> - anonymous usage
                metrics;
                <br />{" "}
              </li>
              <li>
                <strong>Advertising / third-party cookies</strong> - with
                consent for marketing.
                <br />{" "}
              </li>
            </ul>
            <p>
              You can manage cookie settings via the cookie banner and your
              browser. Our cookie practice follows standard industry and
              regulatory guidance.
            </p>
            <ol start="7">
              <li>
                <strong> Sharing personal data </strong>
              </li>
            </ol>
            <p>
              We disclose personal data only as necessary and with safeguards:
            </p>
            <ul>
              <li>
                <strong>Employers / Job Seekers,</strong> when you apply or
                choose to display contact details.
                <br />{" "}
              </li>
              <li>
                <strong>Service providers/processors,</strong> payment
                processors, cloud hosting, identity verification and
                background-check partners, analytics providers governed by
                written contracts.
                <br />{" "}
              </li>
              <li>
                <strong>Legal/regulatory authorities</strong> where required by
                law or to respond to lawful requests.
                <br />{" "}
              </li>
              <li>
                <strong>Business transfers</strong> in M&amp;A scenarios,
                subject to confidentiality and data protection conditions.
                <br />{" "}
              </li>
            </ul>
            <p>
              We do <strong>not</strong> sell personal data. Where international
              transfers occur, we use appropriate safeguards (SCCs, contractual
              protections) as required by GDPR (Chapter V) and DPDPA.
            </p>
            <h3>
              <strong>8. International transfers</strong>
            </h3>
            <p>
              Personal data may be transferred to service providers or
              affiliates in countries outside your jurisdiction. For EEA/UK
              transfers, we use{" "}
              <strong>Standard Contractual Clauses (SCCs)</strong> or other
              lawful mechanisms; for India/DPDP compliance, we adopt contractual
              and technical safeguards required by applicable rules. You can
              request details of transfer mechanisms by contacting our Privacy
              team.
            </p>
            <h3>
              <strong>9. Data retention</strong>
            </h3>
            <p>
              We retain personal data only as long as necessary for the purposes
              set out (account lifecycle, legal obligations, tax &amp; fraud
              investigations). Typical examples:
            </p>
            <ul>
              <li>
                Account data/profile: retained while the account is active;
                archived for a limited period after closure for dispute, tax, or
                legal purposes.
                <br />{" "}
              </li>
              <li>
                Transaction &amp; payment records: retained for statutory
                tax/accounting periods (as required by local laws).
                <br />{" "}
              </li>
              <li>
                Grievances, disputes, or investigations: retained until
                resolution and any appeal period expires.
                <br />{" "}
              </li>
            </ul>
            <p>
              We apply anonymisation or secure deletion when retention is no
              longer necessary. Retention schedules are documented and reviewed
              periodically.
            </p>
            <h3>
              <strong>10. Security</strong>
            </h3>
            <p>
              We implement technical and organisational measures proportional to
              risk, including:
            </p>
            <ul>
              <li>
                Encryption in transit (TLS) and at rest for sensitive fields;
                <br />{" "}
              </li>
              <li>
                role-based access control and logging;
                <br />{" "}
              </li>
              <li>
                regular security testing and vulnerability management;
                <br />{" "}
              </li>
              <li>
                restricted access to PAN/GST documents and secure document
                storage;
                <br />{" "}
              </li>
              <li>
                Incident response and breach notification procedures.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>11. Your rights</strong>
            </h3>
            <h3>
              <strong>11.1 Rights under GDPR</strong>
            </h3>
            <h3>
              You may be entitled to exercise the following rights regarding
              your personal information:
            </h3>
            <p>
              <strong>
                Right to Access:
                <br />{" "}
              </strong>
              You can ask us to confirm whether we are processing your personal
              information. If we are, you may request access to that
              information, including details about why we are processing it and
              what categories of data are involved.
            </p>
            <p>
              <strong>
                Right to Correction:
                <br />{" "}
              </strong>
              You may request that we correct or update any personal information
              that is inaccurate, outdated, or incomplete.
            </p>
            <p>
              <strong>
                Right to Deletion (Right to be Forgotten):
                <br />{" "}
              </strong>
              In certain situations, such as when the information is no longer
              required for its original purpose or when you withdraw your
              consent, you may ask us to delete your personal information.
            </p>
            <p>
              <strong>
                Right to Limit Processing:
                <br />{" "}
              </strong>
              You can request that we limit how your personal information is
              processed under specific circumstances, for example, when the
              accuracy of the data is in question or if you believe the
              processing is unlawful.
            </p>
            <p>
              <strong>
                Right to Know:
                <br />{" "}
              </strong>
              You may request details about the categories and specific types of
              personal information we collect, where we obtain it from, why we
              use it, and the third parties with whom we share it.
            </p>
            <p>
              <strong>
                Right to Data Portability:
                <br />{" "}
              </strong>
              You may ask to receive your personal information in a structured,
              commonly used, and machine-readable format. Where technically
              possible, you may also request that we transfer this information
              directly to another organization.
            </p>
            <p>
              <strong>
                Right to Object:
                <br />{" "}
              </strong>
              You may object to the processing of your personal information for
              certain purposes, such as direct marketing or processing based on
              our legitimate interests.
            </p>
            <p>
              <strong>
                Right to Withdraw Consent:
                <br />{" "}
              </strong>
              If we process your personal information based on your consent, you
              can withdraw that consent at any time. This will not affect any
              processing that took place before the withdrawal.
            </p>
            <h3>
              <strong>11.2 Rights under DPDP Act, 2023 </strong>
            </h3>
            <p>
              Under the{" "}
              <strong>Digital Personal Data Protection Act, 2023</strong>, you
              have several rights that allow you to manage and control how your
              personal data is handled. These include:
            </p>
            <p>
              <strong>
                Right to Access:
                <br />{" "}
              </strong>
              You may request details about the personal data we hold about you.
            </p>
            <p>
              <strong>
                Right to Correction:
                <br />{" "}
              </strong>
              You can ask us to correct, update, or complete any personal data
              that is inaccurate or incomplete.
            </p>
            <p>
              <strong>
                Right to Erasure:
                <br />{" "}
              </strong>
              You may request that your personal data be deleted, unless we are
              legally required to retain it for compliance or regulatory
              purposes.
            </p>
            <p>
              <strong>
                Right to Nominate:
                <br />{" "}
              </strong>
              You have the right to appoint another person who can act on your
              behalf and exercise your data rights in the event of your death or
              inability to do so.
            </p>
            <p>
              <strong>
                Right to Withdraw Consent:
                <br />{" "}
              </strong>
              You may withdraw your consent to the processing of your personal
              data at any time. Once withdrawn, we will stop processing your
              data unless the law requires us to continue.
            </p>
            <h3>
              <strong>11.3 How to exercise your rights</strong>
            </h3>
            <p>
              To exercise any right, submit a request via Email
              <strong>:</strong>{" "}
              <a href="mailto:Privacy@hourlee.in">Privacy@hourlee.in</a> ,
              include full name, registered email, user ID, and specific
              request.
              <br />{" "}
            </p>
            <p>
              We will verify identity before fulfilling requests. We handle
              requests promptly and in accordance with applicable law within 1
              month.
            </p>
            <ol start="12">
              <li>
                <strong> Grievance redressal </strong>
              </li>
            </ol>
            <p>
              If you have any questions, concerns, complaints, or grievances
              regarding the processing of your personal data or this Privacy
              Notice, you may contact us at{" "}
              <a href="mailto:Privacy@hourlee.in">
                <strong>Privacy@hourlee.in</strong>
              </a>
              <strong> .</strong> We are committed to handling all grievances in
              a fair, timely, and transparent manner.
            </p>
            <p>
              Upon receipt of a grievance, we will acknowledge it within{" "}
              <strong>24 hours</strong> and endeavour to resolve the matter
              within <strong>90 working days</strong>, in accordance with the
              provisions of the{" "}
              <strong>Digital Personal Data Protection Act, 2023</strong>.
            </p>
            <h3>
              <strong>13. Children</strong>
            </h3>
            <p>
              Hourlee is not intended for children. We do not knowingly collect
              personal data of persons under the age of 18. If we become aware
              of such data, we will take steps to remove it.
            </p>
            <h3>
              <strong>14. Third-party links &amp; social integrations</strong>
            </h3>
            <p>
              Our Service may link to third-party websites or use third-party
              services (social logins, analytics). These third parties have
              their own privacy practices. We are not responsible for their
              processing. Always consult the third party&rsquo;s privacy policy
              before providing personal data to them.
            </p>
            <h3>
              <strong>15. Data Protection Officer &amp; contact details</strong>
            </h3>
            <p>For privacy enquiries, DSARs, or grievances, please contact:</p>
            <p>
              <strong>
                Data Protection / Grievance Team
                <br />{" "}
              </strong>
              RightO Services Private Ltd. (Hourlee)
              <br /> Address: 52/1 Park Road, Dehradun - 248001, India
              <br />{" "}
            </p>
            <p>
              <strong>Email : </strong>
              <a href="mailto:Privacy@hourlee.in">
                <strong>Privacy@hourlee.in</strong>
              </a>
            </p>
            <p>
              <strong>Phone:</strong> +91-9811999641
            </p>
            <h3>
              <strong>16. Changes to this Notice</strong>
            </h3>
            <p>
              We may update this Notice to reflect changes in law or our
              services. Material changes will be communicated via the Platform
              and, where required, by email. The &ldquo;Last updated&rdquo; date
              will be revised.
            </p>
            <p>&nbsp;</p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default PrivacyPolicy;
